export default {
  path: 'project',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'index',
      name: 'jxxfJcProjectIndex',
      component: () => import('./jcXmList.vue'),
      meta: { navtabTitle: '检测项目管理', isCache: true, ignoreDiff: [], menuElements: [] }
    },
    {
      path: 'create',
      name: 'jxxfJcProjectCreate',
      component: () => import('./jcXmDialog.vue'),
      meta: { navtabTitle: '新建检测项目', isCache: true, ignoreDiff: [], menuElements: [] }
    },
    {
      path: 'edit/:xmId',
      name: 'jxxfJcProjectEdit',
      component: () => import('./jcXmDialog.vue'),
      meta: { navtabTitle: '编辑检测项目', isCache: true, ignoreDiff: [], menuElements: [] }
    },
    {
      path: 'detail/:xmId',
      name: 'jxxfJcProjectDetail',
      component: () => import('./jcXmDetail.vue'),
      meta: { navtabTitle: '查看检测项目', isCache: true, ignoreDiff: [], menuElements: [] }
    }
  ]
};
